import React from 'react';
import { useTranslation } from 'react-i18next';
import './OrderItem.css';

const OrderItem = ({ item, orderId, onStart, onComplete, onReset }) => {
  const { t } = useTranslation();
  const stationId = item.station?.id;

  const handleToggleStatus = () => {
    if (item.status === 'pending' && stationId) {
      onStart(orderId, item.id, stationId);
    } else if (item.status === 'preparing' && stationId) {
      onComplete(orderId, item.id, stationId);
    }
  };

  const handleReset = (e) => {
    e.stopPropagation();
    if (onReset && stationId) onReset(orderId, item.id, stationId);
  };

  const getStatusIcon = () => {
    switch (item.status) {
      case 'pending': return '⭕';
      case 'preparing': return '🔄';
      case 'ready': return '✅';
      default: return '⭕';
    }
  };

  // A started item can be reverted in case a cook tapped it by mistake.
  const canReset = onReset && stationId && item.status !== 'pending';

  return (
    <div
      className={`order-item order-item--${item.status || 'pending'}`}
      onClick={item.status !== 'ready' ? handleToggleStatus : undefined}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && item.status !== 'ready') {
          e.preventDefault();
          handleToggleStatus();
        }
      }}
      role={item.status !== 'ready' ? 'button' : undefined}
      tabIndex={item.status !== 'ready' ? 0 : undefined}
    >
      <div className="order-item__status-icon">{getStatusIcon()}</div>
      <div className="order-item__details">
        <div className="order-item__header">
          <span className="order-item__quantity">{item.quantity}x</span>
          <span className="order-item__name">{item.name}</span>
        </div>
        {item.notes && (
          <div className="order-item__notes">
            <span className="order-item__notes-icon">💬</span>
            <span className="order-item__notes-text">{item.notes}</span>
          </div>
        )}
        {item.station && (
          <div
            className="order-item__station"
            style={{ backgroundColor: item.station.color || '#10B981' }}
          >
            {item.station.name}
          </div>
        )}
      </div>
      {item.status === 'preparing' && item.prepTime && (
        <div className="order-item__prep-time">~{item.prepTime} {t('kitchen.min')}</div>
      )}
      {canReset && (
        <button
          type="button"
          className="order-item__undo"
          onClick={handleReset}
          title={t('kitchen.undoItem')}
          aria-label={t('kitchen.undoItem')}
        >
          ↩
        </button>
      )}
    </div>
  );
};

export default OrderItem;
